import { Routes, RouterModule } from '@angular/router';
import { AccountCandidatesLayoutComponent } from './layout/account-candidates-layout.component';
import { AccountCandidatesListComponent } from './list/account-candidates-list.component';
import { AccountCandidateComponent } from './candidate/account-candidate.component';
import { AccountCandidateAttributeComponent } from './attributes/account-candidate-attributes.component';
import { AccountCandidateTagsComponent } from './tags/account-candidate-tags.component';

const accountCandidatesRoutes: Routes = [
  // Account routes
  {
    path: '',
    //outlet: 'Candidates',
    component: AccountCandidatesLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      { path: 'list', component: AccountCandidatesListComponent },
      { path: 'details/:candidate_id', component: AccountCandidateComponent },
      { path: 'tags', component: AccountCandidateTagsComponent },
      { path: 'attributes', component: AccountCandidateAttributeComponent },
    ],
  },
];

export const AccountCandidatesRouting = RouterModule.forChild(
  accountCandidatesRoutes,
);
